import gql from 'graphql-tag';

const NEWS_ARTICLE_FIELDS = `
  id
  slug
  title
  excerpt
  image
  publishedAt
  featuredSlot
`;

export const NEWS_ARTICLES = gql`
  query NEWS_ARTICLES($search: String, $first: Int, $page: Int) {
    newsArticles(search: $search, first: $first, page: $page) {
      data {
        ${NEWS_ARTICLE_FIELDS}
      }
      paginatorInfo {
        currentPage
        lastPage
        total
      }
    }
  }
`;

export const NEWS_ARTICLE = gql`
  query NEWS_ARTICLE($slug: String!) {
    newsArticle(slug: $slug) {
      ${NEWS_ARTICLE_FIELDS}
      body
    }
  }
`;

export const NEWSROOM = gql`
  query NEWSROOM {
    newsroom {
      featured {
        ${NEWS_ARTICLE_FIELDS}
      }
      mediaKitUrl
      multimediaThumbnails {
        images
        news
        videos
        mediaKit
      }
    }
  }
`;

export const NEWS_MEDIA = gql`
  query NEWS_MEDIA($type: NewsMediaType!) {
    newsMedia(type: $type) {
      id
      title
      description
      thumbnailUrl
      fileUrl
      downloadUrl
      publishedAt
    }
  }
`;
